function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
import e from "@swup/plugin";
function t(e) {
  return "title" !== e.localName && !e.matches("[data-swup-theme]");
}
function s(e, t) {
  return e.outerHTML === t.outerHTML;
}
function n(e) {
  return e.matches("link[rel=stylesheet][href]");
}
var o = /*#__PURE__*/function (_e) {
  _inherits(o, _e);
  var _super = _createSuper(o);
  function o() {
    var _this;
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, o);
    _this = _super.call(this);
    var _o = _assertThisInitialized(_this);
    _this.name = "SwupHeadPlugin", _this.requires = {
      swup: ">=4.6"
    }, _this.defaults = {
      persistTags: !1,
      persistAssets: !1,
      awaitAssets: !1,
      timeout: 3e3
    }, _this.options = void 0, _this.updateHead = function (e, _ref) {
      _objectDestructuringEmpty(_ref.page);
      try {
        var u = e.to.document,
          _ref2 = function (e, n) {
            var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
              _ref3$shouldPersist = _ref3.shouldPersist,
              o = _ref3$shouldPersist === void 0 ? function () {
                return !1;
              } : _ref3$shouldPersist;
            var r = Array.from(e.children),
              i = Array.from(n.children),
              u = (l = r, i.reduce(function (e, t, n) {
                return l.some(function (e) {
                  return s(t, e);
                }) || e.push({
                  el: t,
                  index: n
                }), e;
              }, []));
            var l;
            var a = function (e, t) {
              return e.reduce(function (e, n) {
                return t.some(function (e) {
                  return s(n, e);
                }) || e.push({
                  el: n
                }), e;
              }, []);
            }(r, i);
            return a.reverse().filter(function (_ref4) {
              var e = _ref4.el;
              return t(e);
            }).filter(function (_ref5) {
              var e = _ref5.el;
              return !o(e);
            }).forEach(function (_ref6) {
              var t = _ref6.el;
              return e.removeChild(t);
            }), u.filter(function (_ref7) {
              var e = _ref7.el;
              return t(e);
            }).forEach(function (_ref8) {
              var t = _ref8.el,
                _ref8$index = _ref8.index,
                s = _ref8$index === void 0 ? 0 : _ref8$index;
              e.insertBefore(t.cloneNode(!0), e.children[s + 1] || null);
            }), {
              removed: a.map(function (_ref9) {
                var e = _ref9.el;
                return e;
              }),
              added: u.map(function (_ref10) {
                var e = _ref10.el;
                return e;
              })
            };
          }(document.head, u.head, {
            shouldPersist: function shouldPersist(e) {
              return _o.isPersistentTag(e);
            }
          }),
          l = _ref2.removed,
          a = _ref2.added;
        _o.swup.log("Removed ".concat(l.length, " / added ").concat(a.length, " tags in head"));
        var c = (r = document.documentElement).lang !== (i = u.documentElement).lang ? (r.lang = i.lang, r.lang) : null;
        c && _o.swup.log("Updated lang attribute: ".concat(c));
        var d = function () {
          if (_o.options.awaitAssets) {
            var _e2 = function (e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return e.filter(n).map(function (e) {
                  return function (e) {
                    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var s = function s(t) {
                      (function (_ref11) {
                        var e = _ref11.href;
                        return Array.from(document.styleSheets).map(function (_ref12) {
                          var e = _ref12.href;
                          return e;
                        }).includes(e);
                      })(e) ? t() : setTimeout(function () {
                        return s(t);
                      }, 10);
                    };
                    return new Promise(function (e) {
                      s(e), t > 0 && setTimeout(e, t);
                    });
                  }(e, t);
                });
              }(a, _o.options.timeout),
              _t = function () {
                if (_e2.length) return _o.swup.log("Waiting for ".concat(_e2.length, " assets to load")), Promise.resolve(Promise.all(_e2)).then(function () {});
              }();
            if (_t && _t.then) return _t.then(function () {});
          }
        }();
        return Promise.resolve(d && d.then ? d.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
      var r, i;
    }, _this.options = _objectSpread(_objectSpread({}, _this.defaults), e), _this.options.persistAssets && !_this.options.persistTags && (_this.options.persistTags = "link[rel=stylesheet], script[src], style");
    return _this;
  }
  _createClass(o, [{
    key: "mount",
    value: function mount() {
      this.before("content:replace", this.updateHead);
    }
  }, {
    key: "isPersistentTag",
    value: function isPersistentTag(e) {
      var t = this.options.persistTags;
      return "function" == typeof t ? t(e) : "string" == typeof t ? e.matches(t) : Boolean(t);
    }
  }]);
  return o;
}(e);
export { o as default };